<div class="modal-content">
    <div class="modal-header text-center">

    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/alert.svg">
        <hr class="w-50 mx-auto">
        <h6 class="mt-2">Estamos teniendo dificultades de comunicación</h6>
    </div>
    <div class="modal-footer">
        <div class="row mx-auto">
            <h6>Tan pronto se restablezca la comunicación estaremos funcionando nuevamente</h6>
        </div>
    </div>
</div>